export const GET_PAYMENT_REQUEST = 'GET_PAYMENT_REQUEST';
export const GET_PAYMENT_SUCCESS = 'GET_PAYMENT_SUCCESS';
export const GET_PAYMENT_FAIL = 'GET_PAYMENT_FAIL';
export const GET_RECENT_PAYMENT_REQUEST = 'GET_RECENT_PAYMENT_REQUEST';
export const GET_RECENT_PAYMENT_SUCCESS = 'GET_RECENT_PAYMENT_SUCCESS';
export const GET_RECENT_PAYMENT_FAIL = 'GET_RECENT_PAYMENT_FAIL';

